import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {
  getPurchaseOrderInboundDetailsApi,
  getPurchaseOrderInboundItemsApi,
} from 'features/PurchaseOrder/services/checkQuantity'
import {
  getInboundTaskCheckQtyItemsSummary,
  postCompleteFlexibleInboundCheckQty,
} from 'features/PurchaseOrder/services/inboundTask'

export const SLICE_NAME = 'inboundTaskCheckQty'

export const fetchPoDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchInboundCheckQty`,
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await getPurchaseOrderInboundDetailsApi(id)
      return data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchInboundCheckQtyItems = createAsyncThunk(
  `${SLICE_NAME}/fetchInboundCheckQtyItems`,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async (id: number, { getState, rejectWithValue }) => {
    try {
      const { paramsInboundItems } = (getState() as StoreStateType).inboundTaskCheckQty
      const { data } = await getPurchaseOrderInboundItemsApi(id, paramsInboundItems)
      return data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchInboundCheckQtyItemsSummary = createAsyncThunk(
  `${SLICE_NAME}/fetchInboundCheckQtyItemsSummary`,
  async (params: { id: number; callbackFunction: () => void }, { rejectWithValue }) => {
    try {
      const { id, callbackFunction } = params
      const { data } = await getInboundTaskCheckQtyItemsSummary(id)
      if (callbackFunction) callbackFunction()
      return data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const completeFlexibleInboundCheckQty = createAsyncThunk(
  `${SLICE_NAME}/completeFlexibleInboundCheckQty`,
  async (params: { id: number; callbackFunction?: () => void }, { rejectWithValue }) => {
    try {
      const { id, callbackFunction } = params
      const { data } = await postCompleteFlexibleInboundCheckQty(id)
      callbackFunction?.()
      return data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
